import { createSelector } from 'reselect';
import { immutableToJS } from '../../devUtils/commonUtils';

const selectYesBankReplaceCardDomain = (state) => state.get('yesBankReplaceCard');
export const selectYesBankReplaceCard = () => createSelector(
  selectYesBankReplaceCardDomain,
  (YesBankReplaceCard) => YesBankReplaceCard,
);

export const isLoading = () => createSelector(
  selectYesBankReplaceCardDomain,
  (YesBankReplaceCard) => YesBankReplaceCard.get('isLoading'),
);

export const replaceCardSuccess = () => createSelector(
  selectYesBankReplaceCardDomain,
  (YesBankReplaceCard) => immutableToJS(YesBankReplaceCard.get('replaceCardSuccess')),
);



// WEBPACK FOOTER //
// client/containers/YesBankReplaceCard/selectors.js